import { getCmsNewsDetailAction } from "../../../Actions/LogicActions/CMSNews/GetCmsNewsDetail";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { INewsDetailGetParams } from "../../../Orchestrator/Types/Interface/ICMSNews";

class NewsDetailInitStep extends StepFlow {
  get stepName() {
    return "NewsDetailInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<INewsDetailGetParams, void>({
        eventName: evtTree.News.Details.Get,
        handler: async ({ data }) => {
          if (data?.slug) {
            getCmsNewsDetailAction.setParams(data!);
            await getCmsNewsDetailAction.execute();
          }
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("NewsDetail Init Step Execute...");
  }
}

export const NewsDetailInitStepDeclaration = new StepDefinition({
  stepName: "NewsDetailInit_Step",
  stepClass: NewsDetailInitStep,
});
